import { FILTER_OPS_NUM } from "../../constants";
import { convertToNumber } from "../../helpers/DataHelpers";
import { batchFilterType } from "../../state";

function isValidFilter(filter: batchFilterType) {
  if (
    filter.column !== "" &&
    filter.column !== undefined &&
    filter.value !== "" &&
    filter.value !== undefined &&
    filter.operation !== "" &&
    filter.operation !== undefined
  ) {
    return true;
  }
  return false;
}

function gt(a, b) {
  return convertToNumber(a) > convertToNumber(b);
}
function lt(a, b) {
  return convertToNumber(a) < convertToNumber(b);
}
function eq(a, b) {
  return a === b;
}
function neq(a, b) {
  return a !== b;
}

export function applyFilter(
  data: any[][],
  headers: string[],
  filters: batchFilterType[]
) {
  let filtered: any[][] = [];
  let validFilters: batchFilterType[] = [];
  for (let filter of filters) {
    if (isValidFilter(filter)) {
      validFilters.push(filter);
    }
  }

  let toDrop: Set<number> = new Set();
  if (validFilters.length === 0) {
    return data;
  }

  for (let filter of filters) {
    let fn = undefined;
    if (filter.operation === FILTER_OPS_NUM.equal) {
      fn = eq;
    } else if (filter.operation === FILTER_OPS_NUM.notEqual) {
      fn = neq;
    } else if (filter.operation === FILTER_OPS_NUM.greater) {
      fn = gt;
    } else if (filter.operation === FILTER_OPS_NUM.less) {
      fn = lt;
    }
    let colIndex = headers.indexOf(filter.column);
    for (let i = 0; i < data.length; i++) {
      if (!fn(data[i][colIndex], filter.value)) {
        toDrop.add(i);
      }
    }
  }

  for (let i = 0; i < data.length; i++) {
    if (toDrop.has(i)) {
      continue;
    } else {
      filtered.push(data[i]);
    }
  }
  return filtered;
}
